var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{attrs:{"slim":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var invalid = ref.invalid;
return [_c('a-modal',{staticClass:"chip-setting-modal modal-overflow-visible",attrs:{"title":_vm.modalTitle,"ok-button-props":{
      props: {
        disabled: invalid
      }
    },"ok-text":_vm.modalOkButtonTitle},on:{"ok":_vm.onOkClick,"close":function($event){_vm.newCurrent = null}},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[(_vm.newCurrent)?[_c(_vm.newCurrent.info.view,{ref:"settingComponent",tag:"component",attrs:{"current-model":_vm.newCurrent,"info":_vm.newCurrent.info,"action":_vm.modalAction,"prefix":_vm.prefix},on:{"on-chips-update":_vm.onChips}}),_c('select-input',{staticClass:"mt-0",attrs:{"setup":{
          'func': _vm.modelSetter,
          'args': {
            'model': _vm.newCurrent,
            'key': 'type',
            'prefix': ("typed_chips_value_" + (_vm.prefix ? _vm.prefix : '')),
            'options': _vm.typeOptions,
            'clearable': false,
          }
        }},on:{"input":_vm.onTypeChange}})]:_vm._e()],2)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }